import { Route } from "react-router-dom";
import { APP_URLS } from "../../../utils/constant";
import RateAdminRateCodeScreen from "../../../container/RateAdminScreen/RateAdminRateCodeScreen";
import CreateRateAdminRateCode from "../../../container/RateAdminScreen/RateAdminRateCodeScreen/CreateRateAdminRateCode";

const RateAdminRateCodeRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.RATEADMIN_RATE_CODE.HOME}
          element={<RateAdminRateCodeScreen screenPermissions={access} />}
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.RATEADMIN_RATE_CODE.CREATE}
          element={<CreateRateAdminRateCode />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.RATEADMIN_RATE_CODE.EDIT}
          element={<CreateRateAdminRateCode isEdit={true} />}
        />
      )}
    </>
  );
};

export default RateAdminRateCodeRoutes;
